/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { InjectionToken } from '@angular/core';
import { FittingTreeViewComponent } from 'libs/sysque/toolbelt/feature/src/lib/components/add-fitting-tab/fitting-tree-view/fitting-tree-view.component';
import { FittingTreeView } from 'libs/sysque/toolbelt/feature/src/lib/models/fitting-tree-view-vm';
import { Observable } from 'rxjs';
import { SystemInfo } from '../system-info';
import { TabDescription } from '../tab-description';
import { PastedItemsInfo } from 'libs/sysque/toolbelt/feature/src/lib/models/pasted-items-info';

export interface IAddFittingModeFacade {
  getFittingTreeViewInstance(): Observable<FittingTreeViewComponent>;
  getTreeViewItem(treeViewDatasource: FittingTreeView[], itemFolderPath: string): FittingTreeView | null;
  updateLocalStorage(key: string, value: any): void;
  updateSystemList(): Observable<SystemInfo[]>;
  getCategories(systemName: string): Observable<TabDescription[]>;
  executePasteItemsAction(replaceItems: PastedItemsInfo[]): void
}

export const ADD_FITTING_MODE_FACADE_TOKEN = new InjectionToken<IAddFittingModeFacade>('ADD_FITTING_MODE_FACADE_TOKEN');
